import React from 'react';
import Home from './components/Home';
import MusicWithLyrics from './components/MusicWithLyrics';

function App() {
  return (
    <div>
      <Home />
      <MusicWithLyrics />
    </div>
  );
}

export default App;
